import React from "react";
import { Button, Input } from "antd";
import DataTable from "../../DataTable/DataTable";
import { SearchOutlined } from "@ant-design/icons";

export const columns = (handlePolicyAction, pagination) => [
  {
    title: "SI NO",
    dataIndex: "si_no",
    key: "si_no",
    render: (_, __, index) => {
      // Calculation is correct and relies on pagination state
      const pageIndex = pagination.current || 1;
      const pageSize = pagination.pageSize || 10;
      return (pageIndex - 1) * pageSize + index + 1;
    },
  },
  {
    title: "POLICY NUMBER",
    dataIndex: "policy_number",
    key: "policy_number",
    sorter: (a, b) => a.policy_number.localeCompare(b.policy_number),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="Search Policy Number"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => confirm()}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => clearFilters()}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    onFilter: (value, record) =>
      record.policy_number.toLowerCase().includes(value.toLowerCase()),
    render: (text, record) => (
      <span
        className="table-clickable-text"
        onClick={() => handlePolicyAction(record)}
      >
        {text}
      </span>
    ),
  },
  {
    title: "POLICY TYPE",
    dataIndex: "policy_type",
    key: "policy_type",
    sorter: (a, b) => a.policy_type.localeCompare(b.policy_type),
  },
  {
    title: "POLICY START DATE",
    dataIndex: "policy_start_date",
    key: "policy_start_date",
    sorter: (a, b) => new Date(a.policy_start_date) - new Date(b.policy_start_date),
  },
  {
    title: "POLICY END DATE",
    dataIndex: "policy_end_date",
    key: "policy_end_date",
    sorter: (a, b) => new Date(a.policy_end_date) - new Date(b.policy_end_date),
  },
  {
    title: "ENROLLMENT TYPE",
    dataIndex: "enrollment_type",
    key: "enrollment_type",
  },
  {
    title: "CREATED AT",
    dataIndex: "created_at",
    key: "created_at",
    sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
  },
];

const EndorseRackRatePolicyList = ({
  loading,
  filteredData,
  pagination,
  handlePolicyAction,
  handleTableChange,
}) => {
  return (
    <DataTable
      columns={columns(handlePolicyAction, pagination)}
      dataSource={filteredData}
      pagination={pagination}
      loading={loading}
      onChange={handleTableChange} // Use the main onChange for all table state updates
    />
  );
};

export default EndorseRackRatePolicyList;